import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=22200b9b&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=22200b9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22200b9b",
  null
  
)

export default component.exports